import {
    CATEGORY as _CATEGORY,
    categoryKey as _categoryKey,
    categoryLabel as _categoryLabel,
    routineObjectiveKey as _routineObjectiveKey,
    routineObjectiveLabel as _routineObjectiveLabel,
    sportLabel as _sportLabel,
    equipmentLabel as _equipmentLabel,
    objectiveLabel as _objectiveLabel,
    typeLabel as _typeLabel,
    folderLabel as _folderLabel,
    placeLabel as _placeLabel,
    blockNameLabel as _blockNameLabel,
    countryLabel as _countryLabel,
    injuryTypeLabel as _injuryTypeLabel,
    injuryZoneLabel as _injuryZoneLabel,
    injuryConditionLabel as _injuryConditionLabel,
    injuryMomentLabel as _injuryMomentLabel,
    injuryComplexityLabel as _injuryComplexityLabel,
    injuryComplexityKey as _injuryComplexityKey,
} from '@/utils/Taxonomy'

export const taxonomyMixin = {
    computed: {
        CATEGORY() {
            return _CATEGORY
        },
    },
    methods: {
        categoryKey(value) {
            return _categoryKey(value)
        },
        categoryLabel(value) {
            return _categoryLabel(value)
        },
        routineObjectiveKey(value) {
            return _routineObjectiveKey(value)
        },
        routineObjectiveLabel(value) {
            return _routineObjectiveLabel(value)
        },
        sportLabel(value) {
            return _sportLabel(value)
        },
        equipmentLabel(value) {
            return _equipmentLabel(value)
        },
        objectiveLabel(value) {
            return _objectiveLabel(value)
        },
        typeLabel(value) {
            return _typeLabel(value)
        },
        folderLabel(folder) {
            return _folderLabel(folder)
        },
        placeLabel(value) {
            return _placeLabel(value)
        },
        blockNameLabel(value) {
            return _blockNameLabel(value)
        },
        countryLabel(value) {
            return _countryLabel(value)
        },
        injuryTypeLabel(value) {
            return _injuryTypeLabel(value)
        },
        injuryZoneLabel(value) {
            return _injuryZoneLabel(value)
        },
        injuryConditionLabel(value) {
            return _injuryConditionLabel(value)
        },
        injuryMomentLabel(value) {
            return _injuryMomentLabel(value)
        },
        injuryComplexityLabel(value) {
            return _injuryComplexityLabel(value)
        },
        injuryComplexityKey(value) {
            return _injuryComplexityKey(value)
        },
    },
}
